




























































































































import { Component, mixins, namespace } from 'nuxt-property-decorator'
import { Context } from '@nuxt/types'
import { BRANDS_API } from '~/assets/config/api-path'
import { IMeta } from '~/assets/interfaces/meta'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentBrandItem from '~/components/brands/brand-item.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import ComponentNavigationBreadcrumbs from '~/components/navigation/breadcrumbs.vue'
import { IBrandBase, IGroupedItems } from '~/assets/interfaces/brands'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import MixinGeneral from '~/assets/mixins/general'
import ComponentBrandItemText from '~/components/brands/brand-item-text.vue'

const pageStore = namespace('page')

const ENDefault = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ']
const RUDefault = [...'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЭЮЯ']
const NUDefault = [...'0123456789']

@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentPageContent,
    ComponentBrandItem,
    ComponentTypographyH1,
    ComponentNavigationBreadcrumbs,
    ComponentBrandItemText,
  },
})
export default class pageBrands extends mixins(MixinGeneral) {
  @pageStore.Mutation('setMeta') private setMeta!: (
    meta: IMeta
  ) => Promise<void>

  private async asyncData({ $axios }: Context) {
    return await $axios.$get(BRANDS_API)
  }

  private breadcrumbs: IBreadcrumbsItem[] = []
  private meta: IMeta | null = null

  private items: IBrandBase[] = []
  private popular: IBrandBase[] = []

  private activeLetter: string = '' // Текущая выбранная буква

  private get getLetters(): string[] {
    return ENDefault.filter((letter) =>
      this.items.some((item) => item.title.charAt(0).toUpperCase() === letter)
    )
  }

  private filterByLetter(letter: string) {
    this.activeLetter = letter
  }

  private get getGroupedItems(): IGroupedItems[] {
    if (!this.items.length) return []

    const sortedItems = this.items
      .filter((item) => ENDefault.includes(item.title.charAt(0).toUpperCase()))
      .sort((a, b) =>
        a.title.localeCompare(b.title, 'en', { sensitivity: 'base' })
      )

    const groupedItems: { [key: string]: IBrandBase[] } = {}

    sortedItems.forEach((item) => {
      const firstChar = item.title.charAt(0).toUpperCase()
      if (!groupedItems[firstChar]) {
        groupedItems[firstChar] = []
      }
      groupedItems[firstChar].push(item)
    })

    return this.getLetters
      .map((letter) => ({
        letter,
        items: groupedItems[letter] || [],
      }))
      .filter((group) => group.items.length > 0)
  }

  private get getNuItems(): IBrandBase[] {
    return this.items.filter((item) => NUDefault.includes(item.title.charAt(0)))
  }

  private get getRuItems(): IBrandBase[] {
    return this.items.filter((item) =>
      RUDefault.includes(item.title.charAt(0).toUpperCase())
    )
  }

  private created(): void {
    if (this.meta) {
      this.setMeta(this.meta)
    }
  }
}
